import { Component,OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { TYPEMODULE, LoaderService, NotificationService, CONSTANT, GridDataSource } from '../../../../shared/session/index';
import { AplicacionService } from '../../Aplicaciones/shared/aplicacion.service';
import { PageEvent, MatPaginator } from '@angular/material';

@Component({
  selector: 'app-office-aplicacion-list',
  // styleUrls: ['table-basic-example.css'],
  templateUrl: 'office-aplicacion-list.component.html',
})

export class OfficeAplicacionListComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
	@Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @Input() typeModule: TYPEMODULE;
  @Input() titlePage: string;
  @Input() data: any;

  pageSize: number;
  pageEvent: PageEvent;
  displayedColumns: string[] ;
  dataSource: GridDataSource;
  msgErrorGet: string;
  selectedRowIndex: number = -1;
  showMessageGridEmpty: boolean = false;
  pageSizeOptions: number[] = CONSTANT.pageSizeOptions;

  constructor(
    private loaderService: LoaderService,
    private aplicacionService: AplicacionService,
    private notificationService: NotificationService
  ) { }

  ngOnInit() {
    this.pageSize = 0; //CONSTANT.pageSize;
    this.pageEvent = new PageEvent();
    this.clearMatPaginator();
    this.msgErrorGet = 'Error al listar las aplicaciones';
    this.displayedColumns = ['AplicacionID','Name','Path','Icono','Descripcion','Status'];
    //this.buscarAplicacion(this.data.office.ID, "");
  }

  searchEmit(data: any) {
		this.buscarAplicacion(this.data.office.ID, data.filtro);
  }

  changeEvent(event) {
    this.onChangeEvent.emit(event);
  }

	buscarAplicacion(OfficeID: number, filtro: string){
    this.clearMatPaginator();
    this.listarApplicationPorOffice(OfficeID, filtro);
  }

  private clearMatPaginator() {
    this.pageEvent.pageIndex = 0;
    this.pageEvent.pageSize = this.pageSize;
    this.pageEvent.length = 0;
  }

  private setMatPaginator() {
    this.paginator.length = this.pageEvent.length;
    this.paginator.pageIndex = this.pageEvent.pageIndex;
    this.paginator.pageSize = this.pageEvent.pageSize;
  }

  private listarApplicationPorOffice(OfficeID:number, filtro: string){
    this.loaderService.show();
    this.aplicacionService.listarApplicationPorOffice(filtro, OfficeID, this.pageEvent.pageIndex, this.pageEvent.pageSize)
    .subscribe(res => {
			// if (this.errorService.getMessageError(res)) {
        this.dataSource = new GridDataSource(res);
        this.showHideMessageGridEmpty(Number(res.length));
        this.pageEvent.length = res.length;
        this.setMatPaginator();
			// }
		},
		error => {
			this.notificationService.error(this.msgErrorGet);
			throw error;
		},
		() => {
			this.loaderService.hide();
		});
  }

  public showHideMessageGridEmpty(rows: number) {
    this.showMessageGridEmpty = false;
    if (rows <= 0) this.showMessageGridEmpty = true;
  }
}

